var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.33335C8.15905 3.33335 6.66667 4.82574 6.66667 6.66669C6.66667 8.5076 8.15905 10 10 10C11.8409 10 13.3333 8.5076 13.3333 6.66669C13.3333 4.82574 11.8409 3.33335 10 3.33335ZM5 6.66669C5 3.90526 7.23857 1.66669 10 1.66669C12.7614 1.66669 15 3.90526 15 6.66669C15 9.4281 12.7614 11.6667 10 11.6667C7.23857 11.6667 5 9.4281 5 6.66669ZM4.84429 13.8471C6.20286 12.9979 8.02785 12.5 10 12.5C11.9722 12.5 13.7972 12.9979 15.1557 13.8471C16.5025 14.6889 17.5 15.9584 17.5 17.5C17.5 17.9603 17.1269 18.3334 16.6667 18.3334C16.2064 18.3334 15.8333 17.9603 15.8333 17.5C15.8333 16.7404 15.3384 15.9267 14.2724 15.2604C13.2181 14.6015 11.7098 14.1667 10 14.1667C8.29025 14.1667 6.78191 14.6015 5.72762 15.2604C4.66159 15.9267 4.16667 16.7404 4.16667 17.5C4.16667 17.9603 3.79357 18.3334 3.33333 18.3334C2.8731 18.3334 2.5 17.9603 2.5 17.5C2.5 15.9584 3.49746 14.6889 4.84429 13.8471Z",
    fill: "#14181F",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.6cc1644ec3f065a8cc3eefef9fd09025.svg";
export { ForwardRef as ReactComponent };